import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import auth from "./modules/auth";
import report from "./modules/report";
import order from "./modules/order";
import cart from "./modules/cart";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user,
    auth,
    report,
    order,
    cart
  },
  strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js